import axios from 'axios';
import router from './router'
import { message, Modal } from 'ant-design-vue';
import { h } from 'vue';
import store from '@/store';
import i18n from './lang';
import { captchaClientId } from '@/utils/captchaClient';

// ===== 被 nginx 拦截时的提示 (429限流=稍候重试; 444封禁/网络不可达=联系客服核实身份) =====
const CONTACT_URL = 'https://www.yuque.com/daweishimoxi/hxieo0/nwt572pgipk3o1t1?singleDoc#';
let _netNoticeTs = 0;
function netNotice(kind) {
    if (kind === 'slow') return;             // 网络慢/超时: 不弹窗(避免误吓 + 防轰炸)
    var now = Date.now();
    if (now - _netNoticeTs < 60000) return;  // 60秒内最多弹一次, 防止弹窗轰炸
    _netNoticeTs = now;
    if (kind === 'ratelimit') {
        Modal.warning({ title: '操作过于频繁', okText: '我知道了',
            content: '您的操作太频繁啦，请稍候片刻（约1分钟）后再试。' });
    } else {
        Modal.confirm({ title: '网络状况不稳定', okText: '联系我们', cancelText: '关闭',
            onOk() { try { window.open(CONTACT_URL, '_blank'); } catch (e) { } },
            content: h('div', {}, [
                h('p', { style: 'margin:6px 0' }, '您当前的网络状况不稳定，请联系管理员核实身份，以便更好地为您服务。'),
                h('p', { style: 'color:#888;margin:0' }, '请点击下方「联系我们」与客服取得联系。')]) });
    }
}
const axiosInstance = axios.create({
    // baseURL: 'http://82.156.174.212:8005/api/', // 统一配置基础 URL
    // baseURL: 'http://47.92.156.237:8007/api/', // 统一配置基础 URL
    // baseURL: 'https://my.zuhaoguanjia.com/api/', // 统一配置基础 URL
    // baseURL: 'https://v2.zuhaoguanjia.com/api/', // 统一配置基础 URL
    baseURL: process.env.VUE_APP_API_BASE_URL,

    // 设置携带cookie
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

axiosInstance.defaults.withCredentials=true; // 向后台发送请求时携带凭证


const noAuthRoutes = ['/login/', '/register/', '/home/', 'userauth/login/', 'api/userauth/login/', 'userauth/get_sms_code/', 'api/userauth/get_sms_code/'];

// 请求拦截器
axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('access_token');
        if (token && !noAuthRoutes.includes(config.url)) {
            config.headers['Authorization'] = `${token}`;
        };
        const captchaUuid = localStorage.getItem('captchaUuid');
        const requestCaptchaUuid = typeof config.headers?.get === 'function'
            ? config.headers.get('x-captcha-uuid')
            : config.headers?.['x-captcha-uuid'];
        // Explicit component UUIDs must stay paired with the image on screen.
        // Keep localStorage only as a compatibility fallback for other screens.
        if (!requestCaptchaUuid && captchaUuid) {
            config.headers['x-captcha-uuid'] = captchaUuid;
        }
        config.headers['x-captcha-client-id'] = captchaClientId();
        config.headers['x-captcha-client-source'] = 'pdd';
        config.headers['language'] = i18n.global.locale || '';
        config.headers['HTTP_ACCEPT_LANGUAGE'] = i18n.global.locale || '';
        config.headers['Accept-Language'] = i18n.global.locale || '';
        
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
    response => {
        const captchaUuid = response.headers['x-captcha-uuid']
        if (captchaUuid) {
            localStorage.setItem('captchaUuid', captchaUuid);
        }

        // 如果包含authorization
        const newToken = response.headers['Authorization'];
        if (newToken) {
            localStorage.setItem('access_token', newToken);
        }
        const alterType = response?.data?.alter_type;
        // 处理非正常业务状态吗，相应提示
        if (response.data.status != 10000 && response.data.msg) {
            if (alterType === 'message') {
                message.error(response.data.msg);
            } else {
                const payload = {
                    tmp: Date.now(), // 确保每次弹窗的 tmp 值不同
                    alterType: "modal", // 或 "message/modal"
                    msg: response.data.msg || "接口请求错误",
                    level: response.data.level || "info",
                    title: response.data.title || "提示",
                  };
                console.log(payload)
                store.dispatch("gobalMessageModal/showModal", payload);
            }
            // 抛出错误，方便调用方捕获和处理
            // return Promise.reject(new Error(response.data.msg));
        }
        if (response.data.status == 10000 && response.data.msg) {
            if (alterType === 'message') {
                message.success(response.data.msg);
            } else {
                const payload = {
                    tmp: Date.now(), // 确保每次弹窗的 tmp 值不同
                    alterType: "modal", // 或 "message/modal"
                    msg: response.data.msg || "接口请求错误",
                    level: response.data.level || "info",
                    title: response.data.title || "提示",
                  };
                console.log(payload)
                store.dispatch("gobalMessageModal/showModal", payload);
            }
        }
        // 身份验证
        if (response.data.status == 10002) {
            store.dispatch("realnameVerificationModal/openRealModal");
        }
        return response;
    },
    error => {
        if (error.response && (error.response.status === 401 || error.response?.data?.status === 10401)) {
            // 清除鉴权信息
            localStorage.removeItem('access_token');
            store.commit('SET_USER', null);  // 清除用户信息
            store.commit('SET_AUTHENTICATED', false);
        } else if (error.response && error.response.status === 429) {
            // 限流(非封禁): 不弹窗, 静默; 只对被封禁(403)弹窗
            console.warn('请求被限流429(不弹窗):', error?.config?.url);
        } else if (error.response && error.response.status === 403) {
            netNotice('banned');                    // 被封禁(nginx/ESA 403): 联系客服核实身份
        } else if (error.response && error.response.status === 404) {
            message.error('页面路径不存在');
        } else if (!error.response) {
            // 无响应=网络错误/超时/连接抖动: 不弹窗(封禁现在统一返回403, 无响应≠被封)
            console.warn('网络请求无响应(不弹窗):', error?.config?.url, error?.code, error?.message);
        }
        return Promise.reject(error);
    }
);

// ===== 只读静态接口: localStorage短期缓存 + 并发去重 (减少重复请求/降后端压力) =====
const READ_TTL = {
    'web/settings_rule/': 3600000, 'web/api/support/details': 3600000,
    'web/get_game_enum_v2/': 3600000, 'web/get_game_platforms/': 3600000,
    'web/get_game_show_rule_list/': 600000, 'web/banners/': 600000,
    'web/notice_control/': 300000, 'web/games-recommend/': 300000,
    'web/get_game_total_count/': 300000,
};
try {
    const _inflight = new Map();
    const LS = window.localStorage; const PFX = 'rc:';
    const _readLang = (hh) => { try { return (hh && (typeof hh.get === 'function' ? hh.get('language') : hh.language)) || ''; } catch (e) { return ''; } };
    const _baseAdapter = axios.getAdapter(axios.defaults.adapter);
    if (typeof _baseAdapter === 'function') {
        axiosInstance.defaults.adapter = (config) => {
            const ttl = READ_TTL[config.url];
            if (!ttl) return _baseAdapter(config);
            const body = typeof config.data === 'string' ? config.data : JSON.stringify(config.data || '');
            const key = PFX + config.url + '|' + body + '|' + _readLang(config.headers);
            try {
                const raw = LS.getItem(key);
                if (raw) { const hit = JSON.parse(raw); if (hit && (Date.now() - hit.t < ttl)) return Promise.resolve({ data: hit.d, status: 200, statusText: 'OK(cache)', headers: {}, config: config, request: {} }); LS.removeItem(key); }
            } catch (e) { /* ignore */ }
            if (_inflight.has(key)) return _inflight.get(key);
            const p = Promise.resolve(_baseAdapter(config)).then((res) => {
                try { const d = res && res.data; const obj = (typeof d === 'string') ? JSON.parse(d) : d; if (obj && obj.status === 10000) LS.setItem(key, JSON.stringify({ t: Date.now(), d: d })); } catch (e) { /* ignore */ }
                _inflight.delete(key); return res;
            }).catch((e) => { _inflight.delete(key); throw e; });
            _inflight.set(key, p); return p;
        };
    }
} catch (e) { console.warn('read-cache adapter init skipped:', e); }

export default axiosInstance;
